import { BookingIntent, StockTargetType } from '../types';
import { BookingRequest } from './booking-request';
import { FromBuilder } from './from-builder';

/**
 * Builder-Stage für Quelle = Bufferstock. Bietet alle fachlich
 * sinnvollen Ziel-Auswahlen an, die von einem Bufferstock aus möglich sind.
 */
export class FromBufferstockBuilder extends FromBuilder {
  /**
   * Bufferstock → Bufferstock: Umlagerung zwischen zwei Bufferstocks.
   * Erzeugt ein NormalMovement; Backend zerlegt das automatisch in zwei
   * Sub-Movements via TransferPoint. Standard-Use-Case der StockBookingPage
   * mit `type=MOVE`.
   *
   * @param id ID des Ziel-Bufferstocks
   * @returns Finale Builder-Stage mit `validate()`/`submit()`
   */
  public toBufferstock(id: number): BookingRequest {
    return this.next(StockTargetType.BUFFERSTOCK, id, BookingIntent.MOVE);
  }

  /**
   * Bufferstock → KFZ: "Entnahme aus Bufferstock" / Befüllung des KFZ.
   * Erzeugt ein CarTransferMovement (KFZ-Beteiligung übersteuert den Intent).
   *
   * @param id ID des Ziel-KFZ
   * @returns Finale Builder-Stage mit `validate()`/`submit()`
   */
  public toCar(id: number): BookingRequest {
    return this.next(StockTargetType.CAR, id, BookingIntent.MOVE);
  }

  /**
   * Bufferstock → Maschine: Standard-Befüll-Buchung. Erzeugt ein OrderMovement
   * (einphasig, Backend bucht Source und Target atomar).
   *
   * @param id ID der Ziel-Maschine
   * @returns Finale Builder-Stage mit `validate()`/`submit()`
   */
  public toMachine(id: number): BookingRequest {
    return this.next(StockTargetType.MACHINE, id, BookingIntent.ORDER);
  }

  /**
   * Bufferstock → Müll: Entsorgung direkt vom Bufferstock. Verbraucht den
   * Bestand am Bufferstock und legt KEINE PositionDisposal an (im Gegensatz
   * zu MachineTrash). Standard-Use-Case der StockBookingPage mit
   * `type=TRASH`. Erzeugt ein TrashMovement.
   *
   * @returns Finale Builder-Stage mit `validate()`/`submit()`
   */
  public toTrashBin(): BookingRequest {
    return this.nextDisposal(StockTargetType.TRASH_BIN, BookingIntent.TRASH);
  }

  /**
   * Bufferstock → Verbrauch: Manueller Verbrauch aus dem Bufferstock
   * (z.B. interne Nutzung, Schulung). Standard-Use-Case der StockBookingPage
   * mit `type=MANUAL`. Erzeugt ein ConsumptionMovement.
   *
   * @returns Finale Builder-Stage mit `validate()`/`submit()`
   */
  public toConsumptionBin(): BookingRequest {
    return this.nextDisposal(
      StockTargetType.CONSUMPTION_BIN,
      BookingIntent.CONSUMPTION,
    );
  }
}
